module.exports = __webpack_public_path__ + "f8d3d043e0cf0b597bbc071f3979f6dc.svg";